import React from 'react'
import { useTranslation } from 'react-i18next'
import { CustomDesignStyle } from '@/components/template/custom-design-style'
import { OkImage } from '@/components/atoms/icon'
import { css } from '@emotion/react'
import { Button } from '@/components/atoms/button'
import { useNavigate } from 'react-router-dom'

export const SurveyDuplicate = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <>
      <CustomDesignStyle />
      <div css={layoutStyle}>
        <OkImage css={imageWrapperStyle} />
        <h2 css={thanksMessageStyle}>{t('Survey already answered')}</h2>
        <p css={[leadStyle, css({ marginBottom: '2rem' })]}>
          {t('The survey has already been answered.')}
          <br />
          {t('Thank you for your cooperation.')}
        </p>
        <Button text={t('TOP')} onClick={() => navigate('/')} />
      </div>
    </>
  )
}

const layoutStyle = css({
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '6rem',
  paddingRight: '1.5rem',
  paddingLeft: '1.5rem',
  overflowY: 'auto',
})

const thanksMessageStyle = css({
  fontSize: '22px',
  marginTop: '2.5rem',
  marginBottom: '2rem',
  textAlign: 'center',
  lineHeight: '1.54',
  whiteSpace: 'pre-wrap',
})

const leadStyle = css({
  textAlign: 'center',
  fontSize: '14px',
  lineHeight: '1.8',
  whiteSpace: 'pre-wrap',
})

const imageWrapperStyle = css({
  width: '182px',
  height: '182px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})
